
import React, { useState, useEffect, createContext, useCallback } from "react";
import cn from "classnames";
import StatusBarBox from "components/StatusBarBox";
import styles from "./StatusBox.module.scss";
import LocalStorageService from "services/tokenlocalstorage.service";
import { getRequest } from "services/axiosBaseClient";
import { numberFormate } from "components/common/numberFormate";
import { numDifferentiation } from "./common/AmountFomatter";

export default function StatusBox(props) {
  // const data = props.ServiceListingurl;
  const [temperature, setTemperature] = useState([{ temp: 0 }]);
  const [revenue, setRevenue] = useState({
    totalRevenue: 0,
    todayRevenue: 0,
    dailyAverage: 0,
    lastRevenue: 0,
  });
  const [topthreeSites, setTopthreeSites] = useState("");
  const [assets, setAssets] = useState({
    TotalSite: 0,
    TotalCharger: 0,
    TotalBattery: 0,
  });
  const [energyPoint, setEnergyPoint] = useState([{ co2: 0, gas: 0 }]);
  const [energyUsed, setEnergyUsed] = useState({
    totalEnergy: 0,
    dailyAverage: 0,
    todayEnergy: 0,
  });

  const [userRole, setUserRole] = useState("");
  const [adminNav, setAdminNav] = useState(false);
  const batteryId = props.batteryId;
  const siteId = props.siteUrlId;
  const swappId = props.swappingId? props.swappingId.includes("-") ? props.swappingId.split("-")[0] : props.swappingId : null;
  const siteName = encodeURIComponent(props.siteNameURL);
  const enterpriseName = encodeURIComponent(props.enterpriseNameURL);
  //const view = encodeURIComponent(props.enterpriseNameURL);
  const view = props.view;
  const batterySerialId = props.batterySerialIId;


  const getTemperature = useCallback(async () => {
    await getRequest("bss/temperature")
      .then((res) => {
        if (res.data != null) {
          setTemperature(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getRevenueData = useCallback(async () => {
    await getRequest(
      "bss/revenue_info" + (batteryId  ? "?batteryId="+batteryId : '')
    )
      .then((res) => {
        if (res.data != null) {
          setRevenue(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getTopThreeSites = useCallback(async () => {
    await getRequest("bss/revenue_info")
      .then((res) => {
        if (res.data != null) {
          setTopthreeSites(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getAssetsData = useCallback(async () => {
    await getRequest(
      // "bss/getTotalAssests?siteId"
      "bss/getTotalAssests" + (siteId ? '?siteId='+siteId : '') +( swappId ? '?swapStationId='+swappId : '')
    )
      .then((res) => {
        if (res.data != null) {
          setAssets(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getEnergyUsedData = useCallback(async () => {
    await getRequest(
      "bss/aggregation/totalEnergy" +
        (siteId === undefined ? '' : "?siteId="+siteId) +
        (batteryId === undefined ? '' : "?batteryId="+batteryId)+
        ( swappId ? '?swapStationId='+swappId : '')
    )
      .then((res) => {
        if (res.data != null) {
          setEnergyUsed(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getEnergyPointData = useCallback(async () => {
    await getRequest(
      "bss/energyPoint" +
        (siteId === undefined ? '' : '?siteId='+siteId) +
        (batteryId === undefined ? '' : "?batteryId=" +batteryId)+
        ( swappId ? '?swapStationId='+swappId : '')
    )
      .then((res) => {
        if (res.data != null) {
          setEnergyPoint(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getTemperature();
    getRevenueData();
    getTopThreeSites();
    getEnergyPointData();
    getAssetsData();
    // getAssetsData();
    getEnergyUsedData();
  }, []);

  var input = {
    header: "Energy Used",
    components: [
      {
        img: "totalEnergy",
        title: "Total Energy",
        value: `${Number(energyUsed.totalEnergy)?.toFixed(2)} kWh`,
      },
      {
        img: "dailyAvg",
        title: "Daily Average",
        value: `${Number(energyUsed.dailyAverage)?.toFixed(2)} kWh`,
      },
      {
        img: "todays",
        title: "Today's",
        value: `${Number(energyUsed.todayEnergy)?.toFixed(2)} kWh`,
      },
    ],
  };

  var inputTemperature = {
    header: "Temperature",
    components: [
      {
        img: "thermometer",
        title: "Outside Temperature",
        value: `${temperature[0].temp}°C`,
      },
    ],
  };

  var inputRevenue = {
    header: "Revenue",
    components: [
      {
        img: "totalRevenue",
        title: "Total Revenue",
        value: `₹ ${numDifferentiation(revenue?.totalRevenue)}`,
      },
      {
        img: "todaysRevenue",
        title: "Today's Revenue",
        value: `₹ ${numDifferentiation(revenue?.todayRevenue)}`,
      },
      {
        img: "dailyAvg",
        title: "Daily Average",
        value: `₹ ${numDifferentiation(revenue?.dailyAverage)}`,
      },
      {
        img: "lastSwappingRevenue",
        title: "Last Swapping Revenue",
        value: `₹ ${numDifferentiation(revenue?.lastRevenue)}`,
      },
    ],
  };

  var inputTopThreeSites = {
    header: "Top 3 Sites",
    components: [
      { img: "noidaSector", title: "Noida Sec 128", value: "₹ 2.5 cr" },
      { img: "noidaSector", title: "Noida Sec 71", value: "₹ 2.1 cr" },
      { img: "noidaSector", title: "Noida Sec 50", value: "₹ 90 lac" },
    ],
  };

  var inputAssets = {
    header: "Assets",
    components: [
      { img: "totalSites", 
        title: `Total Sites`, 
        value: `${assets.TotalSite}`
      },
      {
        img: "totalChargers",
        title: "Total Swap Stations",
        value: `${assets.TotalCharger}`,
      },
      {
        img: "totalBatteries",
        title: "Total Batteries",
        value: `${assets.TotalBattery}`,
      },
    ],
  };
  var inputAssetss = {
    header: "Assets",
    components: [
      {
        img: "totalChargers",
        title: "Total Swap Stations",
        value: `${assets.TotalCharger}`,
      },
      {
        img: "totalBatteries",
        title: "Total Batteries",
        value: `${assets.TotalBattery}`,
      },
    ],
  };

  var inputEnergyPoints = {
    header: "Energy Points",
    components: [
      {
        img: "leaf",
        title: "lbs of CO₂ Saved",
        value: `${numberFormate(energyPoint[0].co2)}`,
      },
      {
        img: "gasPump",
        title: "Gallons of Gas Saved",
        value: `${numberFormate(energyPoint[0].gas)}`,
      },
    ],
  };

  useEffect(() => {
    setUserRole(LocalStorageService.get("user-role"));
    userRole.toLocaleLowerCase() === "admin"
      ? setAdminNav(true)
      : setAdminNav(false);
  });

  return (
    <>
      <div
      id="status_main_block"
        className={`ssddbb ${cn(
          styles.cover_block1,
          styles.cover_block1_layout
        )}`}
      >
        <div id="status_block_layout" className={cn(styles.block5, styles.block5_layout)}>
          {props.Url === "/Dashboard" ? (
            <>
              <StatusBarBox data={input} />{" "}
              {adminNav ? "" : <StatusBarBox data={inputRevenue} />}{" "}
              {adminNav ? "" : <StatusBarBox data={inputTopThreeSites} />}
              <StatusBarBox data={inputAssets} />
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}
          {props.dUrl === "/sites" ? (
            <>
              <StatusBarBox data={input} /> <StatusBarBox data={inputAssets} />{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}
          {props?.siteUrl?.includes(`/sites/site/${siteId}`) ? (
            <>
              <StatusBarBox data={input} />
              {props.activeSitetabId === 1 ? (
                <StatusBarBox data={inputAssetss} />
              ) : (
                <StatusBarBox data={inputAssets} />
              )}{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}
          {props.batteryUrl === "/batteries" ? (
            <>
              <StatusBarBox data={input} /> <StatusBarBox data={inputRevenue} />{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}
          {props.batteryNameUrl ===
          `/batteries/battery/${batteryId}/${batterySerialId}` ? ( ///pass serialId here get it in some variable from parent page
            <>
              <StatusBarBox data={input} /> <StatusBarBox data={inputRevenue} />{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}
          {props.swappingUrl === "/SwapStation" ||
          props?.swapUrl?.includes(`/SwapStation/SwapStation/`) ? (
            <>
              <StatusBarBox data={input} /> 
              <StatusBarBox data={inputAssets} />{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}
          {props.swapUrl === "/Swapping" ||
          props?.swapUrl?.includes(`/Swapping/`) ? (
            <>
              <StatusBarBox data={input} /> <StatusBarBox data={inputAssets} />{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}
          {props.ServiceRequesturl === "/ServiceRequest" ? (
            <>
              <StatusBarBox data={input} />{" "}
              {<StatusBarBox data={inputRevenue} />}{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}
          {props.ServiceListingurl === "/ServiceRequest/ServiceListing" ||
          props?.ServiceListingurl?.includes(`/ServiceRequest/ViewService/`) ||
          props?.ServiceListingurl?.includes(`/ServiceRequest/UpdateService/`) ? (
            <>
              <StatusBarBox data={input} />{" "}
              {<StatusBarBox data={inputRevenue} />}{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )}

          {/* {trimdata === "UpdateService" ? (
            <>
              <StatusBarBox data={input} />{" "}
              {<StatusBarBox data={inputRevenue} />}{" "}
              <StatusBarBox data={inputTemperature} />
              <StatusBarBox data={inputEnergyPoints} />
            </>
          ) : (
            ""
          )} */}
        </div>
      </div>
    </>
  );
}

StatusBox.inStorybook = true;
